import { Html, useProgress } from '@react-three/drei'

export default function LoaderProgress() {
  const { 
    progress
  } = useProgress()
  return (<Html center>Loading... {progress.toFixed(0)}%</Html>);
};
